import { useState } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { SimpleDashboardLayout } from '../components/layout/SimpleDashboardLayout'
import { ContainerProvider } from '../contexts/ContainerContext'
import { ExpectedContainersView } from './containers/ExpectedContainersView'
import { OnYardContainersView } from './containers/OnYardContainersView'
import { TripModal } from '../components/containers/TripModal'
import type { Container } from '../types/container'

function ContainersPage() {
  const [selectedContainer, setSelectedContainer] = useState<Container | null>(null)
  const [isTripModalOpen, setIsTripModalOpen] = useState(false)

  const handleContainerClick = (container: Container) => {
    setSelectedContainer(container)
    setIsTripModalOpen(true)
  }

  const handleTripModalClose = () => {
    setIsTripModalOpen(false)
    setSelectedContainer(null)
  }

  return (
    <SimpleDashboardLayout>
      <ContainerProvider>
        <div className="bg-white rounded-lg p-8 shadow-sm">
          <Routes>
            <Route
              path="expected"
              element={
                <ExpectedContainersView
                  onContainerClick={handleContainerClick}
                />
              }
            />
            <Route
              path="on-yard"
              element={
                <OnYardContainersView
                  onContainerClick={handleContainerClick}
                />
              }
            />
            <Route path="*" element={<Navigate to="expected" replace />} />
          </Routes>
        </div>

        {/* Trip Details Modal */}
        <TripModal
          container={selectedContainer}
          isOpen={isTripModalOpen}
          onClose={handleTripModalClose}
        />
      </ContainerProvider>
    </SimpleDashboardLayout>
  )
}

export default ContainersPage
